import React, { useState, useEffect, useRef } from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { fontFamilyall, primaryColor } from "../../../UtilColorPalate/UtilColorPalate";
import { stats } from "../../../Data/data";

const BestSellers = () => {
  const [animatedNumbers, setAnimatedNumbers] = useState(stats.map(() => 0));
  const sectionRef = useRef(null);
  const observerRef = useRef(null);
  
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAnimation();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observerRef.current.observe(sectionRef.current);
    }

    return () => {
      if (observerRef.current && sectionRef.current) {
        observerRef.current.unobserve(sectionRef.current);
      }
    };
  }, []);

  const startAnimation = () => {
    const intervals = stats.map((stat, index) => {
      let currentNumber = 0;
      const increment = Math.ceil(stat.number / 50);
      return setInterval(() => {
        currentNumber += increment;
        if (currentNumber >= stat.number) {
          currentNumber = stat.number;
          clearInterval(intervals[index]);
        }
        setAnimatedNumbers((prevNumbers) => {
          const newNumbers = [...prevNumbers];
          newNumbers[index] = currentNumber;
          return newNumbers;
        });
      }, 30);
    });

    setTimeout(() => {
      intervals.forEach((interval) => clearInterval(interval));
    }, 2000);
  };

  const numberStyle = {
    fontWeight: "900",
    fontSize: "50px",
    fontFamily: "'Arial Black', sans-serif",
    color: primaryColor,
    marginBottom: "-20px",
  };

  return (
    <div ref={sectionRef} style={{ marginTop: "50px" }}>
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={6} sm={6} md={3} key={index}>
            <Card sx={{ textAlign: "center", p: 2, boxShadow: "none" ,}}>
              <h1 style={numberStyle}>
                {animatedNumbers[index]}
                {index < 3 ? "+" : "%"}
              </h1>
              <CardContent>
                <Typography variant="h6"   style={{fontFamily:fontFamilyall}}>{stat.label}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default BestSellers;
